<template>
    <div style="z-index: 999 !important;" class="under-development rounded " v-if="shouldBlock">
        <h3 :style="{'color': CASE_COLOR[overlayDisplayStatus] || CASE_COLOR[_gHlp.getValue(product,'prod_main_status')]}">{{ overlayDisplayStatus }}</h3>
    </div>
</template>

<script>
import {CASE_COLOR} from '@/assets/js/colors.js'
import {UNEDITABLE_STATUS} from '@/assets/js/status.js'
export default {
    props: ['product'],
    data(){
        return{
            UNEDITABLE_STATUS:UNEDITABLE_STATUS,
            CASE_COLOR:CASE_COLOR
        }
    },
    computed: {
        overlayDisplayStatus() {
            if (this.product != null && this.product.prod_approval_status === null && this.product.prod_approval_id == null) {
                return 'Application Pending'
            }
            return _gHlp.getValue(this.product, 'prod_main_status')
        },
        shouldBlock(){
            if (this.product != null && this.product.prod_approval_status === null && this.product.prod_approval_id == null) {
                return true
            }
            const mainStatus = _gHlp.getValue(this.product, 'prod_main_status')
            const banks = _gHlp.getValue(this.product,'product_banks',[])
            // Application-level statuses always block the whole case
            const applicationBlockStatuses = ['Application Pending', 'Application Rejected', 'Application Cancelled']
            // Case-level terminal statuses — only block when no active banks remain
            const terminalCaseStatuses = ['Rejected','Declined by client','Cancelled']
            const terminalBankStageStatuses = ['Rejected','Rejected by Bank','Declined by client','Declined by Client','Cancelled','Cancel Application','Cancelled by Bank']

            if(applicationBlockStatuses.includes(mainStatus)){
                return true
            }

            const norm = (s) => String(s || '').trim().toLowerCase()
            const terminals = terminalBankStageStatuses.map(s => s.toLowerCase())
            const hasBanks = Array.isArray(banks) && banks.length > 0
            const isBankTerminal = (b) => terminals.includes(norm(_gHlp.getValue(b,'prod_bnk_stage_status')))
            const hasActiveBank = hasBanks && banks.some(b => !isBankTerminal(b))

            // e.g. one bank "Rejected by Bank" must not disable other banks still in progress
            if(terminalCaseStatuses.includes(mainStatus)){
                if (hasBanks && hasActiveBank) {
                    return false
                }
                return true
            }
            
            if(hasBanks){
                // Block only when every bank is in a terminal status
                return banks.every(isBankTerminal)
            }

            return false
        }
    }
}
</script>
